
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/best-note-taking-apps",
      function () {
        return require("private-next-pages/articles/best-note-taking-apps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/best-note-taking-apps"])
      });
    }
  